import { render, staticRenderFns } from "./UiCarousel.vue?vue&type=template&id=28faf4b3"
import script from "./UiCarousel.vue?vue&type=script&lang=js"
export * from "./UiCarousel.vue?vue&type=script&lang=js"
import style0 from "./UiCarousel.vue?vue&type=style&index=0&id=28faf4b3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports